import PropTypes from "prop-types"
import {
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
} from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"

export default function ListItemRadioGroup({
  label,
  value,
  options,
  setValue,
  disabled,
  disabledTooltip,
  orientation = "horizontal",
  classes,
  secondaryAction = () => null,
  disableItemTooltip = false,
}) {
  const handleSelect = (value) => {
    setValue(value)
    secondaryAction()
  }

  const radioItems = options.map((opt, index) => {
    const { id, primaryText, secondaryText, disabled: optDisabled, tooltip } = opt

    let controlLabel = (
      <FormControlLabel
        key={`${id}-${index}`}
        value={id}
        control={<Radio />}
        disabled={disabled || Boolean(optDisabled)}
        label={
          <Box display="flex" alignItems="center" gap={1} className="radio-label-content">
            <div className="radio-primary-text">{primaryText}</div>
            {secondaryText && !(tooltip && disableItemTooltip) && <OPTooltip title={secondaryText} placement="bottom-start">
              <InfoOutlined />
            </OPTooltip>}
          </Box>
        }
      />
    )
    if (tooltip) {
      controlLabel = (
        <Tooltip key={`${id}-${index}-tooltip`} title={tooltip} placement="bottom-start">
          {controlLabel}
        </Tooltip>
      )
    }
    return controlLabel
  })

  const groupControl = (
    <FormControl
      component="fieldset"
      disabled={disabled}
    >
      <FormLabel component="h3" className={classes?.label} focused={false}>
        {label}
      </FormLabel>
      <RadioGroup
        value={value}
        onChange={(e) => handleSelect(e.target.value)}
        className="radio-group-options"
        row={orientation === "horizontal"}
      >
        {radioItems}
      </RadioGroup>
    </FormControl>
  )

  return (
    <div>
      {disabledTooltip ? (
        <Tooltip title={disabledTooltip} placement="bottom-start">
          <span>{groupControl}</span>
        </Tooltip>
      ) : (
        groupControl
      )}
    </div>
  )
}

export const OPTION_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  primaryText: PropTypes.node.isRequired,
  secondaryText: PropTypes.node,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  group: PropTypes.number,
})

ListItemRadioGroup.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(OPTION_SHAPE).isRequired,
  setValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string,
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  secondaryAction: PropTypes.func,
  classes: PropTypes.object,
  disableItemTooltip: PropTypes.bool,
}
